import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MaintenanceType } from '@core/interfaces';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { sentry } from 'sentry';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

const SEARCH_QUERY = gql`
  query searchMaintenanceTypes($where: MaintenanceTypeWhereInput, $limit: Int, $offset: Int) {
    maintenanceTypes(
      where: $where
      orderBy: name_asc
      limit: $limit
      offset: $offset
    ){
      items {
        id
        name
        archived
      }
    }
  }
`;

@Component({
  selector: 'fc-maintenance-types-input',
  templateUrl: './fc-maintenance-types-input.component.html',
  styleUrls: ['./fc-maintenance-types-input.component.scss']
})
export class FcMaintenanceTypesInputComponent {
  @Input()
  public control: FormControl;

  @Input()
  public requiredMark: Boolean = false;

  @Input()
  private shouldDisplayArchived: Boolean = false;

  constructor(
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private apollo: Apollo
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
    this.search = this.search.bind(this);
    this.displayWith = this.displayWith.bind(this);
  }

  async search(searchTerm: string, limit: number, offset: number): Promise<MaintenanceType[]> {
    const where = {
      name_contains: searchTerm,
    };

    if (!this.shouldDisplayArchived) {
      where['archived'] = false;
    }

    return this.apollo
      .query({
        query: SEARCH_QUERY,
        variables: {
          where: where,
          limit: limit,
          offset: offset
        },
      })
      .toPromise()
      .then((result) => result.data['maintenanceTypes']['items'])
      .catch((err) => {
        sentry.captureException(err);
        return [];
      });
  }

  displayWith(value: MaintenanceType): string {
    return value && value.name;
  }
}
